import React, { useState, useEffect } from 'react'
// import './index.css'
import { Contract, CurrencyList } from '../../types'
import { Structure } from '../../../Org/Structure/types'

import HoverTooltip from '../../../../../components/HoverTooltip'

type Props = {
    keyindex: number
    stage: string
    contract: Contract
    structData: Structure[]
    selected: boolean
    onClick: (contract_reg_number: string) => void
    onDoubleClick: (contract_reg_number: string) => void
    onRightClick: (contract_reg_number: string) => void
    theme: string
    currency: CurrencyList[]
}

const CONTRACT_STATUS = new Map([
    ['F', 'Редактирование'],
    ['P', 'Размещено'],
    ['I', 'Недействительно'],
    ['M', 'Изменение'],
])

const CONTRACT_DRAFT_STATUS = new Map([
    ['P', 'Размещение'],
    ['A', 'Аннулирование позиции'],
    ['N', 'Новая позиция'],
    ['C', 'Изменение позиции'],
])

const MONTHS = [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь',
]

const GWS = new Map([
    ['G', 'Товар'],
    ['W', 'Работа'],
    ['S', 'Услуга'],
])

const ContractsTableRow: React.FC<Props> = ({
    keyindex,
    stage,
    contract,
    structData,
    selected,
    onClick,
    onDoubleClick,
    onRightClick,
    theme,
    currency,
}) => {
    const getNameStruct = (struct_guid: string) => {
        const nameSctruct = structData.find((s) => s.guid === struct_guid)
        return nameSctruct?.struct_short_name || '-'
    }

    const updatedDate = new Date(contract.sys_updated_at)
    updatedDate.setHours(updatedDate.getHours())

    const formattedUpdateDate = updatedDate
        .toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
        .replace(/\//g, '.')
    const formattedUpdateTime = updatedDate.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    })

    const createdDate = new Date(contract.sys_created_at)
    createdDate.setHours(createdDate.getHours())

    const STATUS_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Черновик', '#8D79FF'],
                  ['Готово', '#049664'],
                  ['Подготовка', '#745CFF'],
                  ['Готово к отправке', '#563AF5'],
                  ['Отправлено в ЕИС', '#049664'],
                  ['Размещена', '#636366'],
                  ['Недействительно', '#636366'],
                  ['Договор на исполнении', '#049664'],
                  ['Просрочен', '#a85252'],
                  ['Исполнение договора завершено', '#515055'],
                  ['Договор расторгнут', '#515055'],
                  ['Исполнение договора прекращено', '#515055'],
                  ['Осталось меньше 10 дней', '#aa8c08'],
                  ['Осталось меньше 5 дней', '#d5701d'],
                  ['Возможно исполнен', '#aa8c08'],
              ])
            : new Map([
                  ['Черновик', '#DFDDFF'],
                  ['Готово', '#83D2B7'],
                  ['Подготовка', '#D3CFFF'],
                  ['Готово к отправке', '#B7ACFF'],
                  ['Отправлено в ЕИС', '#83D2B7'],
                  ['Размещена', '#CFD6E2'],
                  ['Недействительно', '#CFD6E2'],
                  ['Договор на исполнении', '#83d2b7'],
                  ['Просрочен', '#ed9cae'],
                  ['Исполнение договора завершено', '#cfd6e2'],
                  ['Договор расторгнут', '#cfd6e2'],
                  ['Исполнение договора прекращено', '#cfd6e2'],
                  ['Осталось меньше 10 дней', '#e0c963'],
                  ['Осталось меньше 5 дней', '#d5701d'],
                  ['Возможно исполнен', '#e0c963'],
              ])

    const STAGE_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Редактирование', '#745CFF'],
                  ['Подготовка к размещению', '#563AF5'],
                  ['Отправка в ЕИС', '#4406BE'],
                  ['Размещенный договор', '#636366'],
                  ['Исполнение договора', '#067d54'],
                  ['Договор закрыт', '#515055'],
              ])
            : new Map([
                  ['Редактирование', '#D3CFFF'],
                  ['Подготовка к размещению', '#B7ACFF'],
                  ['Отправка в ЕИС', '#A191FF'],
                  ['Размещенный договор', '#CFD6E2'],
                  ['Исполнение договора', '#41c497'],
                  ['Договор закрыт', '#cfd6e2'],
              ])

    const suppliers = contract?.suppliers ?? []

    const suppliersText =
        suppliers.length > 1
            ? suppliers
                  .map(
                      (sup, index) => `${index + 1}. ${sup.supplier_short_name}`
                  )
                  .join(', ')
            : suppliers.map((sup) => sup.supplier_short_name).join('')
    return (
        <div
            className={
                selected
                    ? 'plan-position-table-row-selected'
                    : 'plan-position-table-row'
            }
            onDoubleClick={() => onDoubleClick(contract.contract_reg_number)}
            onClick={() => onClick(contract.contract_reg_number)}
            onContextMenu={(e) => {
                e.preventDefault() // Отключает стандартное контекстное меню
                onRightClick(contract.contract_reg_number)
            }}
        >
            <div className="flex h-[70px] w-8 items-center justify-center text-center">
                <input
                    type="checkbox"
                    checked={selected}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => {
                        onClick(contract.contract_reg_number)
                    }}
                />
            </div>
            <div className="flex h-[70px] w-12 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                {keyindex}
            </div>
            <div className="flex h-[70px] p-1 w-20 items-center justify-center text-center">
                <HoverTooltip
                    tooltipText={
                        contract.contract_name ? contract.contract_name : '-'
                    }
                >
                    <p className="tworow">
                        {contract.contract_name
                            ? contract.contract_name.length > 10
                                ? contract.contract_name.slice(0, 10) + '...'
                                : contract.contract_name
                            : '-'}
                    </p>
                </HoverTooltip>
            </div>
            <div
                className={`flex h-[70px] w-24 p-1 items-center justify-center text-center rounded`}
                style={{
                    backgroundColor: contract.contract_stage
                        ? STAGE_COLOR.get(contract.contract_stage)
                        : 'transparent',
                }}
            >
                {contract.contract_stage}
            </div>
            <div
                className="flex h-[70px] w-24 p-1 items-center justify-center text-center rounded"
                style={{
                    backgroundColor: contract.contract_status
                        ? STATUS_COLOR.get(contract.contract_status)
                        : 'transparent',
                }}
            >
                {contract.contract_status}
            </div>

            <div className="flex h-[70px] flex-1 items-center justify-start text-left min-w-44 px-2 ">
                <HoverTooltip
                    tooltipText={
                        contract.subject_contract
                            ? contract.subject_contract
                            : '-'
                    }
                >
                    <p className="fourrow">
                        {contract.subject_contract
                            ? contract.subject_contract
                            : '-'}
                    </p>
                </HoverTooltip>
            </div>

            <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 gap-1">
                <HoverTooltip
                    tooltipText={
                        contract.currency_digital_code
                            ? String(
                                  currency.find(
                                      (c) =>
                                          c.num_code ===
                                          String(contract.currency_digital_code)
                                  )?.name
                              )
                            : '-'
                    }
                >
                    <span>
                        {contract.currency_digital_code
                            ? contract.currency_digital_code == 643
                                ? ''
                                : currency.find(
                                      (c) =>
                                          c.num_code ===
                                          String(contract.currency_digital_code)
                                  )?.char_sign || '?'
                            : ''}{' '}
                        {Number(contract.price).toLocaleString('ru-RU', {
                            minimumFractionDigits: 2,
                        })}
                    </span>
                </HoverTooltip>
            </div>

            <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 ">
                {contract.contract_date
                    ?.split('-')
                    .reverse()
                    .join('-')
                    .replace(/[\-]/g, '.')}
            </div>
            <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 ">
                {contract.end_execution_date
                    ?.split('-')
                    .reverse()
                    .join('-')
                    .replace(/[\-]/g, '.')}
            </div>
            <div className="flex flex-col h-[70px] w-44 items-center justify-center text-center">
                <HoverTooltip
                    tooltipContent={
                        suppliers.length > 1
                            ? suppliers.map((sup, index) => (
                                  <div key={index}>
                                      {index + 1}. {sup.supplier_short_name}
                                  </div>
                              ))
                            : suppliers.map((sup, index) => (
                                  <div key={index}>
                                      {sup.supplier_short_name}
                                  </div>
                              ))
                    }
                >
                    <p className="tworow">{suppliersText}</p>
                </HoverTooltip>
            </div>
            <div className="flex h-[70px] w-24 items-center justify-center text-center">
                {contract.type_object_contract
                    ? GWS.get(String(contract.type_object_contract))
                    : '-'}
            </div>
            <HoverTooltip
                tooltipText={`${contract.struct_name ? contract.struct_name : 'Отсутствует'}`}
                align="center"
            >
                <div className="flex h-[70px] w-24 items-center justify-center text-center">
                    {contract.struct_guid !== undefined &&
                    contract.struct_guid !== null &&
                    contract.struct_guid !== ''
                        ? getNameStruct(contract.struct_guid)
                        : '-'}
                </div>
            </HoverTooltip>
            <div className="flex h-[70px] w-40 items-center justify-center text-center">
                {contract.contract_reg_number}
            </div>
            <div className="flex h-[70px] w-20 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                {formattedUpdateDate}
                <br />
                {formattedUpdateTime}
            </div>
            <div className="flex h-[70px] w-14 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                <HoverTooltip
                    tooltipText={
                        contract.first_name !== null
                            ? contract.last_name + ' ' + contract.first_name
                            : 'Отсутствует'
                    }
                    align="left"
                >
                    <div className="flex h-8 w-8 rounded-full items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d9dce0] dark:bg-[#333033]">
                        {contract.first_name !== null
                            ? contract.last_name?.charAt(0) +
                              contract.first_name?.charAt(0)
                            : 'О'}
                    </div>
                </HoverTooltip>
            </div>
        </div>
    )
}

export default ContractsTableRow
